import { MutationCache, QueryClient } from '@tanstack/react-query';

import {
  CONNECTIONS_QUERY_KEY,
  INBOX_QUERY_KEY,
  MESSAGES_QUERY_KEY,
  NOTIFICATIONS_MANAGEMENT_QUERY_KEY,
  PAYMENT_RECONCILIATION_QUERY_KEY,
  PRICING_CONFIGS_QUERY_KEY,
  RELATIONSHIPS_QUERY_KEY,
  STATS_QUERY_KEY,
  TASKS_QUERY_KEY,
  TRANSACTIONS_QUERY_KEY,
} from 'services/repositories/queryKeys';
import { isLocal } from 'support/helpers/generic/generic';

const QUERY_KEYS_TO_CLEAR = [
  STATS_QUERY_KEY,
  INBOX_QUERY_KEY,
  MESSAGES_QUERY_KEY,
  TRANSACTIONS_QUERY_KEY,
  CONNECTIONS_QUERY_KEY,
  RELATIONSHIPS_QUERY_KEY,
  NOTIFICATIONS_MANAGEMENT_QUERY_KEY,
  PRICING_CONFIGS_QUERY_KEY,
  PAYMENT_RECONCILIATION_QUERY_KEY,
  TASKS_QUERY_KEY,
];

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: isLocal() ? 'always' : 'online',
      refetchOnWindowFocus: false, // Not sure how this would play with our forms
      refetchOnReconnect: false, // Not sure how this would play with our forms
      retry: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
    mutations: {
      networkMode: isLocal() ? 'always' : 'online',
    },
  },
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      queryClient.invalidateQueries({
        predicate: (query) => {
          if (mutation.meta?.shouldInvalidateGlobal === false) {
            return false;
          }
          const queryKey = query.queryKey as Array<string>;
          return QUERY_KEYS_TO_CLEAR.some((key) => queryKey[0]?.startsWith(key));
        },
      });
    },
  }),
});
